module.exports = __webpack_public_path__ + "img/back_width.7885d597.png";